module.exports = __webpack_public_path__ + "stopnudge1-679608232e1408efc8f6.png";